module.exports = __webpack_public_path__ + "static/media/slider1.beb6e32e.jpg";